import { render, staticRenderFns } from "./shiftListing.vue?vue&type=template&id=5aab58ee&"
import script from "./shiftListing.vue?vue&type=script&lang=js&"
export * from "./shiftListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports